import React, { useEffect, useState } from 'react';


const News = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  return (
   <div className='bg-white '>
     <div className='px-4 md:px-40 pt-3'>
      <h1 className="text-[14px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">HAVE YOU REGISTERED AS A FARMER</h1>
      <h1 className="text-[15px] md:text-[32px] font-bold mb-8 text-black">Agri-Tech , The future of Agriculture.</h1>

      <div className="relative w-full  overflow-hidden  rounded-lg bg-white">
        <div className="relative w-full rounded-lg">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[#742B3E] border-solid"></div>
            </div>
          )}
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745011981/image_37_tbvafc.png"
            alt="Securing Agriculture in Namibia"
            className={`w-full md:h-[622px] object-cover   rounded-lg transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
            onLoad={() => setIsLoading(false)}
          />
          {!isLoading && (
            <div className="absolute bottom-6 md:left-9 w-full px-4">
      
            </div>
          )}
        </div>
      </div>

      <div className='px-1'>
  {/* Content Section */}
  <div className="mt-5 max-w-screen-xl w-full">
    <h3 className="text-black font-normal text-[14px] md:text-[32px]">April 13, 2025</h3>
    <div className="flex items-center gap-6 md:gap-8 text-[13px] md:text-[30px] font-normal text-black">
      <p>Story by Editorial team</p>
      <div className="flex items-center gap-2 text-[#155528]">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
          alt="Clock"
          className="h-6 w-6 md:h-8 md:w-8"
        />
        <p>2 Minutes read</p>
      </div>
    </div>
  </div>

  <h3 className="text-black font-bold text-[22px] md:text-[40px] mt-5">Have you registered as a Farmer?</h3>
  <h3 className="text-black font-normal text-[22px] md:text-[40px] mt-5">Registering as a farmer in Namibia is essential for accessing various benefits that enhance agricultural productivity, market access, and compliance with regulatory standards</h3>

  {/* Main Text Section */}
  <div className="mt-5 space-y-10">

  <h3 className="text-black font-bold text-[10px] md:text-[32px] mt-7">Key advantages include:</h3>

  <div className="space-y-6 text-[10px] md:text-[32px] text-black font-normal">

    <div>
      <strong className='font-bold'>Market Access and Recognition</strong><br />
      Registration with relevant authorities, such as the Namibian Agronomic Board (NAB), officially recognizes farmers as legitimate producers. This recognition facilitates entry into both formal and informal markets, expanding sales opportunities.<br/>
      <strong className='font-bold'>Production Zone Allocation</strong><br />
      Upon registration, farmers are assigned to specific production zones (e.g., Zambezi, Kavango, Karst, North Central, Central, South, or Orange). This allocation helps in organizing production efforts and addressing regional market demands effectively.
    <br/>
    <strong className='font-bold'>Compliance with Food Safety Standards</strong><br />
    Registered farmers are informed about food safety regulations, ensuring that their produce meets quality standards. This compliance is crucial for consumer health and facilitates access to both local and international markets.
    <br/>
    <strong className='font-bold'>Access to Production Forecasts and Market Information</strong><br />
      Registration provides farmers with valuable insights into market trends, production forecasts, and demand volumes. This information aids in strategic planning, allowing farmers to align production with market needs and optimize profitability.
<br/>
<strong className='font-bold'>Protection from Import Competition</strong><br />
      The NAB enforces regulations that prioritize local producers, protecting them from cheaper imports. Registered farmers benefit from policies that favor local production, ensuring a more stable and supportive market environment.
<br/>
<strong className='font-bold'>Eligibility for Government Support and Incentives</strong><br />
      Registered farmers are better positioned to receive government support, such as subsidies, training, and access to programs aimed at enhancing agricultural productivity and sustainability.
<br/>
<strong className='font-bold'>Participation in Agricultural Associations</strong><br />
      Joining agricultural associations, like the Namibia National Farmers Union (NNFU), offers additional benefits, including networking opportunities, advocacy, and access to specialized training programs.
  <br/>
  <br/>

  In summary, registering as a farmer in Namibia unlocks numerous opportunities for growth, support, and success in the agricultural sector, contributing to both individual prosperity and national food security
    </div>


  </div>
<br/>
<br/>

<a href='/Register_As_Farm'>

<div className='flex'>
<button className='md:text-[36px] font-bold text-[14px] rounded-bl-lg rounded-tl-lg w-full md:h-[140px] h-[60px] md:p-3 p-1 text-center justify-center items-center flex bg-[#2E453D] text-white'>
    Register as a farmer
  </button>
  <img
    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744564362/Expand_right_uaawcr.png"a
    alt='///'
    className='md:w-[140px] w-[50px] md:h-[140px] h-[60px] rounded-br-lg  rounded-tr-lg md:p-10 p-3 md:py-12 py-3  bg-[#152C24]'
  />
</div>
</a>

  <div className='md:h-5 h-2'></div>
</div>

</div>

    </div>
   </div>
  );
};

export default News;
